export async function mintCableTicket(apiHost: string, token: string): Promise<string> {
  const res = await fetch(`${apiHost}/cable_tickets`, {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) {
    throw new Error(`cable ticket mint failed: ${res.status}`);
  }
  const body = await res.json();
  if (!body.ticket) {
    throw new Error("cable ticket mint returned no ticket");
  }
  return body.ticket;
}
